import React from "react";
import { Menu, Search, Bell, User } from "lucide-react";
import logoAtletain from "../../utils/Logo_Atletain.png";

/**
 * Navy app bar shown only below `lg` (the desktop sidebar replaces it at ≥1024px).
 * Mirrors the top bar in every mobile mockup: hamburger + logo on the left,
 * search / notifications / profile on the right. It is a normal flex child of the
 * shell's content column (not fixed), so it stays put while the page scrolls below.
 */
const MobileTopBar = ({
  className = "",
  onMenuClick,
  onSearchClick,
  onNotificationsClick,
  onProfileClick,
}) => {
  // 44px touch target (WCAG / iOS minimum) with the icon visually centered.
  const iconBtn =
    "grid h-11 w-11 place-items-center rounded-lg text-white/90 transition-colors hover:bg-white/10 active:bg-white/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60";

  return (
    <header
      className={`flex flex-shrink-0 items-center justify-between bg-blue-900 pl-2 pr-2 text-white ${className}`}
      style={{
        // On the web, env(safe-area-inset-top) is 0 → a plain 4rem (h-16) bar,
        // identical to before. On iOS the navy fill bleeds up behind the status
        // bar while the icon row stays 4rem tall *below* the inset (instead of
        // the old fixed h-16, where the inset padding crushed the icons).
        paddingTop: "env(safe-area-inset-top)",
        minHeight: "calc(4rem + env(safe-area-inset-top))",
      }}
    >
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={onMenuClick}
          className={iconBtn}
          aria-label="Abrir menú"
        >
          <Menu size={24} />
        </button>
        <img
          src={logoAtletain}
          alt="Athletain"
          className="h-9 w-9 object-contain"
        />
      </div>

      <div className="flex items-center gap-0.5">
        {onSearchClick && (
          <button
            type="button"
            onClick={onSearchClick}
            className={iconBtn}
            aria-label="Buscar"
          >
            <Search size={22} />
          </button>
        )}
        <button
          type="button"
          onClick={onNotificationsClick}
          className={iconBtn}
          aria-label="Notificaciones"
        >
          <Bell size={22} />
        </button>
        <button
          type="button"
          onClick={onProfileClick}
          className={`${iconBtn} border border-white/25`}
          aria-label="Mi perfil"
        >
          <User size={20} />
        </button>
      </div>
    </header>
  );
};

export default MobileTopBar;
